<template>
  <div>
    <LogoHome />
    <v-container fluid grid-list-md text-center>
      <v-layout row wrap>
        <v-flex xs12 md4 offset-md4>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-card
                class="elevation-15 clickable transparente pa-1"
                v-ripple="{ center: true }"
                @click="abrirOpcion('Venta')"
                dark
              >
                <v-card-text>
                  <span class="overline">Comprobantes</span>
                  <p class="body-2 font-weight-thin"></p>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 md6>
              <v-card
                class="elevation-15 clickable transparente pa-1"
                v-ripple="{ center: true }"
                @click="abrirOpcion('ClienteCrud')"
                dark
              >
                <v-card-text>
                  <span class="overline">Clientes</span>
                  <p class="body-2 font-weight-thin"></p>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 md4>
              <v-card
                class="elevation-15 clickable transparente pa-1"
                v-ripple="{ center: true }"
                @click="abrirOpcion('VentaListarLibroIva')"
                dark
              >
                <v-card-text>
                  <span class="overline">Libro IVA Ventas</span>
                  <p class="body-2 font-weight-thin"></p>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 md4>
              <v-card
                class="elevation-15 clickable transparente pa-1"
                v-ripple="{ center: true }"
                @click="abrirOpcion('VentaListarPorCliente')"
                dark
              >
                <v-card-text>
                  <span class="overline">Ficha del Cliente</span>
                  <p class="body-2 font-weight-thin"></p>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 md4>
              <v-card
                class="elevation-15 clickable transparente pa-1"
                v-ripple="{ center: true }"
                @click="abrirOpcion('VentaListarSaldos')"
                dark
              >
                <v-card-text>
                  <span class="overline">Saldos Deudores</span>
                  <p class="body-2 font-weight-thin"></p>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import LogoHome from "@/components/LogoHome";
export default {
  name: "HomeVenta",
  components: {
    LogoHome
  },
  methods: {
    abrirOpcion(ruta) {
      if (ruta != this.$route.name)
        this.$router.push({ name: ruta, params: {} });
    }
  }
};
</script>
